import React from "react";
import { IonContent, IonButton, IonIcon } from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import LottieAnimation from "../../helpers/LottieComponent";
import congratsAnimation from "../../../assets/animations/success.json";
import analytics from "../../../services/firebaseAnalytics";
interface CompleteIntroProps {
  prevStep: () => void;
  // handleComplete: () => void;
  nextStep: () => void;
  currentStep: number;
  steps: any[];
}

const CompleteIntro: React.FC<CompleteIntroProps> = ({
  prevStep,
  // handleComplete,
  nextStep,
  currentStep,
  steps,
}) => {
  // Log analytics event when component is mounted
  React.useEffect(() => {
    const logAnalyticsEvent = async () => {
      await analytics.logEvent("onboarding_complete_intro_viewed", {});
    };
    logAnalyticsEvent();
    // Only run on mount or when selectedTreatments changes
  }, []);
  return (
    <IonContent className="ion-padding onboarding-section">
      <div className="navigation-header">
        <button className="back-text-button" onClick={prevStep}>
          <IonIcon icon={chevronBack} className="back-icon" />
          <span>Back</span>
        </button>
      </div>

      <div
        className=""
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <h1 className="form-title !mb-0">Congrats!</h1>
        <LottieAnimation
          // height={
          //   window.innerWidth < 768 ? 200 : window.innerWidth < 1024 ? 250 : 300
          // }
          animationData={congratsAnimation}
          loop={false}
          speed={1.5}
          style={{
            width: "100%",
            height: "auto",
            maxHeight: window.innerWidth < 768 ? "300px" : undefined,
          }}
        />{" "}
        <div className="" style={{ width: "100%" }}>
          <p className="instruction-text">
            You have completed the onboarding process. You can now start using
            the app and explore its features.
          </p>
        </div>
      </div>

      <div className="button-stack-container">
        <IonButton expand="block" className="primary-button" onClick={nextStep}>
          Get Started
        </IonButton>
        <button className="skip-link" onClick={nextStep}></button>
      </div>
    </IonContent>
  );
};

export default CompleteIntro;
